<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <el-row>
        <el-col class="item-select l" :span="5">
          <label>审批类型：</label>
          <el-select clearable v-model="form.approvalType" size="mini" placeholder="请选择">
            <el-option v-for="item,i in approvalTypeName" :key="item" :label="item" :value="i">
            </el-option>
          </el-select>
          <!-- <el-select v-model="filter.type" size="mini" placeholder="请选择">
            <el-option v-for="item in typeArr" :key="item.type" :label="item.title" :value="item.type">
            </el-option>
          </el-select> -->
        </el-col>
        <el-col class="item-select l" v-if="form.type!=0" :span="5">
          <label>当前状态：</label>
          <el-select v-model="form.status" size="mini" placeholder="请选择">
            <el-option v-for="item in statusArr" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-col>
        <el-col class="item-input" :span="8">
          <label>搜索：</label>
          <el-input v-model="form.searchName" size="mini" placeholder="你可以搜索审批主体/负责人"></el-input>
        </el-col>
      </el-row>
    </div>
    <div class="tab-radio-tool">
      <el-radio-group size="mini" v-model="form.type">
        <el-radio-button label="2"><span style="line-height:22px;">我提交的审批</span></el-radio-button>
        <el-radio-button label="0">待审批<span class="num">{{tipNum.spNum}}</span>/即将审批<span
            class="num">{{tipNum.dspNum-tipNum.spNum}}</span></el-radio-button>
        <el-radio-button label="1">您已审批<span class="num">{{tipNum.yspNum}}</span></el-radio-button>
      </el-radio-group>
    </div>

    <el-table :data="paginationData" style="width: 100%" v-loading="loading">
      <el-table-column type="index" label="序号" width="40">
      </el-table-column>
      <!-- <el-table-column prop="projectNumber" label="项目编号" width="100px">
      </el-table-column>
      <el-table-column label="工程名称">
        <template slot-scope="scope">
          {{scope.row.projectName}}
        </template>
      </el-table-column> -->
      <el-table-column label="审批主体">
        <template slot-scope="scope">
          <span v-html="getApprovalTypeName(scope.row)"></span>{{ (scope.row.type!=0&&scope.row.type!=1) ?
          scope.row.name : scope.row.flow.remark?("\""+scope.row.flow.remark+"\""):'' + scope.row.name }}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="department" label="所属公司" width="180px">
      </el-table-column> -->
      <el-table-column label="申请表类型" width="135px">
        <template slot-scope="scope">
          <strong class="approval-project-type">
            <span v-html="getApprovalTitle(scope.row)"></span>
            <!-- <span v-if="scope.row.subType">
              {{ approvalTitle["key_"+scope.row.type] }}
            </span>
            <span v-else>
              {{ approvalTitle["key_"+scope.row.type] }}
            </span> -->
          </strong>
        </template>
      </el-table-column>
      <el-table-column label="审批发起人" width="150px">
        <template slot-scope="scope">
          <user-info :userData='scope.row.creator'></user-info>
        </template>
      </el-table-column>

      <el-table-column v-if="form.type==0 || form.type==2" label="审批提交时间" width="135px">
        <template slot-scope="scope">
          <span v-html="getDateByTime(scope.row.createTime)"></span>
        </template>
      </el-table-column>
      <el-table-column v-else label="您的审批时间" width="135px">
        <template slot-scope="scope">
          <span v-html="getDateByTime(scope.row.approvalTime)"></span>
        </template>
      </el-table-column>

      <el-table-column label="审批状态" width="100px" align="center">
        <template slot-scope="scope">
          <approval-status :flow="scope.row.flow" :canAddApproval="form.type==0" :approvals="scope.row.flow.approvals"
            :status="scope.row.flow.status"></approval-status>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120px">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="projectDetail(scope.row)">详情</el-button>
          <el-button v-if="scope.row.flow.isCurUser && !scope.row.flow.isCurUserArrpoval" size="mini"
            @click="arpproval(scope.row)" type="primary">审批</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination v-if="pageTotal>form.pageSize" class="list-pagination" background :page-size="form.pageSize"
      :pager-count="9" :current-page="form.page+1" layout="pager" :total="pageTotal"
      @current-change="handleCurrentChange">
    </el-pagination>

    <project-info></project-info>

    <!-- 添加审批人弹窗
    <div class="pop-room" v-if="addStatus">
      <a href="javascript:;" @click="addStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-form ref="form" label-width="120px" class="form">
            1122
          </el-form>
        </el-col>
      </div>
    </div> -->


  </div>
</template>

<script>
  import approvalList from '@/Mixins/approvalList'
  export default {
    mixins: [approvalList],
    data() {
      return {
        addStatus: true,
      }
    },
  };

</script>



// WEBPACK FOOTER //
// src/page/user/approvallist.vue